import React, { useState } from "react";
import { KeyRound, Mail } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";

export const ResetPasswordButton = ({ endpoint, name, testId }) => {
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState("link");
  const [pwd, setPwd] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(endpoint, mode === "link" ? { mode } : { mode, password: pwd });
      toast.success(mode === "link" ? `Reset link emailed to ${data.email}` : `Temporary password set for ${name}`);
      setOpen(false); setPwd(""); setMode("link");
    } catch (e) { toast.error(apiError(e)); }
    finally { setBusy(false); }
  };
  const opt = (v, Icon, label, hint) => (
    <button type="button" data-testid={`${testId}-mode-${v}`} onClick={() => setMode(v)}
      className={`w-full text-left border rounded-md px-4 py-3 transition-colors ${mode === v ? "border-[#2B4C3F] bg-[#2B4C3F]/8" : "border-border hover:bg-secondary/60"}`}>
      <span className="text-sm font-medium flex items-center gap-2"><Icon className="h-4 w-4" />{label}</span>
      <span className="block text-xs text-muted-foreground ml-6 mt-0.5">{hint}</span>
    </button>
  );
  return (
    <>
      <Button variant="ghost" size="sm" className="h-8 text-xs" data-testid={testId} onClick={(e) => { e.stopPropagation(); setOpen(true); }}>
        <KeyRound className="h-3.5 w-3.5 mr-1" />Reset password
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid={`${testId}-dialog`} onClick={(e) => e.stopPropagation()}>
          <DialogHeader>
            <DialogTitle className="font-head">Reset password · {name}</DialogTitle>
            <DialogDescription>Any existing sessions are signed out once the new password is set.</DialogDescription>
          </DialogHeader>
          <div className="space-y-2">
            {opt("link", Mail, "Email a reset link", "They choose their own new password (link valid 1 hour)")}
            {opt("set", KeyRound, "Set a temporary password", "You share it with them directly")}
          </div>
          {mode === "set" && (
            <div>
              <Label className="overline">Temporary password (min 8 characters)</Label>
              <Input data-testid={`${testId}-password-input`} type="text" autoComplete="off" value={pwd} onChange={(e) => setPwd(e.target.value)} className="mt-1.5" />
            </div>
          )}
          <DialogFooter>
            <Button data-testid={`${testId}-submit`} onClick={submit} disabled={busy || (mode === "set" && pwd.length < 8)}>
              {busy ? "Working…" : mode === "link" ? "Send reset link" : "Set password"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
